import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, ScrollRestoration, useLocation } from 'react-router';

import { ErrorFallback } from '@/components/errors/error';
import { NavigationLayout } from '@/components/layouts/navigation-layout';
import { LoadingOverlay, LoadingSpinner } from '@/components/ui/spinner';
import { useTenant } from '@/hooks/use-tenant';

export const AppRoot = () => {
  console.info('root.tsx_1');

  const location = useLocation();
  const tenant = useTenant();
  const tenantId = tenant.tenantId;

  return (
    <LoadingOverlay>
      <ScrollRestoration />
      <NavigationLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <ErrorBoundary
            key={location.pathname}
            FallbackComponent={ErrorFallback}
          >
            {tenantId !== undefined && <Outlet />}
          </ErrorBoundary>
        </Suspense>
      </NavigationLayout>
    </LoadingOverlay>
  );
};
